<template>
  <div class="container">
    <div class="line_item">
      <div>头像设置</div>
      <div>
        <van-uploader :after-read="Uploader">
          <van-image fit="cover" class="avatarImg" :src="photo" round />
        </van-uploader>
        <div class="iconfont icon-right"></div>
      </div>
    </div>
    <router-link to="/myFile">
      <div class="line_item">
        <div>我的资料</div>
        <div class="iconfont icon-right"></div>
      </div>
    </router-link>
  </div>
</template>
<script>
import { Toast, Uploader, Image } from "vant";
import { loginInfo, updateMemberPhoto } from "@/api/member";
import { uploadImg } from "@/api/publish";
export default {
  name: "userSetting",
  components: {
    "van-uploader": Uploader,
    "van-image": Image,
  },
  data() {
    return {
      photo: "",
    };
  },
  methods: {
    //获取个人信息
    getPersonInfo() {
      var data = {};
      loginInfo(data).then((res) => {
        this.photo = res.Data.Photo;
      });
    },

    //上传图片
    Uploader(file) {
      const param = new FormData();
      param.append("file", file.file);
      uploadImg(param).then((res) => {
        this.photo = res.Data;
        updateMemberPhoto({ HeadlineLogo: res.Data }).then((res) => {
          Toast("头像已上传");
        });
      });
    },
  },
  mounted() {
    this.getPersonInfo();
  },
};
</script>
<style lang="less" scoped>
.container {
  min-height: 100vh;
  background-color: #efefef;
  .line_item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    color: #333333;
    background-color: #fff;
    height: 60px;
    border-bottom: 1px solid #e5e5e5;
    padding: 0 12px;
    &:first-child {
      border-top: 1px solid #e5e5e5;
    }
    div {
      display: flex;
      align-items: center;
      .avatarImg {
        width: 40px;
        height: 40px;
        display: block;
        margin-right: 5px;
      }
      .icon-right {
        font-size: 12px;
        color: #666;
        margin-left: 4px;
      }
    }
  }
}
</style>
